// libraries
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { AnimatePresence, motion } from "framer-motion";
import classNames from "classnames/bind";

// api
import { getEventByCategory } from "../../utils/api";

// components
import { ListWrap } from "src/components";

// assets
import ThreeDotsDark from "src/assets/icons/three-dots-dark.svg";

import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const Events = ({
  heading,
  items,
  user,
  userLocation,
  category,
  isTopSpace,
}) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const pageCount = useRef(1);

  useEffect(() => {
    setData(items);
  }, [items]);

  const loadMoreEvents = () => {
    setIsLoading(true);

    if (!isLoading) {
      pageCount.current += 1;

      let params = {
        catgId: category.Categoryid,
        pageNumber: pageCount.current,
        lat: userLocation?.lat,
        lng: userLocation?.lng,
      };

      if (user) {
        params = {
          ...params,
          userId: user.userId,
          accessToken: user.accessToken,
          lat: user?.location?.lat,
          lng: user?.location?.lng,
        };
      }

      getEventByCategory(params)
        .then((res) => {
          if (res.data.Status) {
            setData([...data, ...res.data.Results]);
            setIsLoading(false);
          } else {
            // toast.error(res.data.ErrorMessage);
            toast.error("no more events  found");
            setIsLoading(false);
          }
        })
        .catch((err) => {
          toast.error(err);
          setIsLoading(false);
        });
    }
  };

  return (
    <div className={cx({ "events-root": isTopSpace })}>
      <ListWrap heading={heading} items={data} />
      {data && data.length > 0 && (
        <AnimatePresence>
          {isLoading ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className={styles.img__wrapper}
            >
              <img src={ThreeDotsDark} alt="loading" />
            </motion.div>
          ) : (
            <button className={styles.btn} onClick={loadMoreEvents}>
              Load more
            </button>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

export default Events;
